import React from "react"
import { SearchHeader } from "../../../components/SearchHeader"
import Options from "./Options"

const SearchOptions = ({ setSearchParam, searchParam, handleOpenImportModal }) => {
  return (
    <>
      <SearchHeader searchParam={searchParam} setSearchParam={setSearchParam} />
      <Options handleOpenImportModal={handleOpenImportModal} />
    </>
  )
}

export default SearchOptions
